<template>
    <div>
        <!-- 用户个人信息 -->
        <div class="common-form">用户信息（修改后的信息小程序用户可查看，请妥善修改）</div>
        <table border="1" style="border-collapse: collapse;width: 100%;" class="grxx">
            <tr>
                <th> 在租设备台数 </th>
                <th> 最早租赁时间</th>
                <th> 征信状况</th>
                <th> 芝麻信用分 </th>
                <th> 公积金余额</th>
                <th> 花呗额度</th>
                <th> 信用卡额度 </th>
                <th> 银行贷款额度 </th>
                <th> 工作单位 </th>
                <th> 职业状况 </th>
                <th> 收入方式</th>
                <th> 收入状况</th>
                <th> 婚姻状况 </th>
                <th> 车贷状况 </th>
                <th> 社保状况 </th>
                <th> 住所性质 </th>
            </tr>
            <tr class="trinfo">
                <!-- <th @click="operate('zaizu',setlist,'在租设备台数')"> {{ lianxiinfo.zaizu }} </th>
                <th @click="operate('zaizutime',timelist,'最早租赁时间')"> {{ lianxiinfo.zaizutime }} </th>
                <th @click="operate('zhengxin',radiolist1,'征信状况')"> {{ lianxiinfo.zhengxin }} </th>
                <th @click="operate('zmxinyongfen', zmxinyongfenlist, '芝麻信用分')"> {{ lianxiinfo.zmxinyongfen }} </th>
                <th @click="operate('gjjmoney',gjjlist,'公积金余额')"> {{ lianxiinfo.gjjmoney }} </th>
                <th @click="operate('huabei',hblist,'花呗额度')"> {{ lianxiinfo.huabei }} </th>
                <th @click="operate('creditCardLimit',xyklist,'信用卡额度')"> {{ lianxiinfo.creditCardLimit }} </th>
                <th @click="operate('bankLoanLimit',yhlist,'银行贷款额度')"> {{ lianxiinfo.bankLoanLimit }} </th>
                <th @click="operate('cpnName','','工作单位')"> {{ lianxiinfo.cpnName }} </th>
                <th @click="operate('zhiye','','职业状况')"> {{ lianxiinfo.zhiye }} </th>
                <th @click="operate('incometype',radiolist2,'收入方式')"> {{ lianxiinfo.incometype }} </th>
                <th @click="operate('income',srlist,'收入状况')"> {{ lianxiinfo.income }} </th>
                <th @click="operate('marriStatus',radiolist3,'婚姻状况')"> {{ lianxiinfo.marriStatus }} </th>
                <th @click="operate('carLoan',radiolist4,'车贷状况')"> {{ lianxiinfo.carLoan }} </th>
                <th @click="operate('shebao',radiolist6,'社保状况')"> {{ lianxiinfo.shebao }} </th>
                <th @click="operate('resiStatus',radiolist5,'住所性质')"> {{ lianxiinfo.resiStatus }} </th> -->
                <th @click="operate('zaizu','','在租设备台数')"> {{ lianxiinfo.zaizu }} </th>
                <th @click="operate('zaizutime','','最早租赁时间')"> {{ lianxiinfo.zaizutime }} </th>
                <th @click="operate('zhengxin',radiolist1,'征信状况')"> {{ lianxiinfo.zhengxin }} </th>
                <th @click="operate('zmxinyongfen', '', '芝麻信用分')"> {{ lianxiinfo.zmxinyongfen }} </th>
                <th @click="operate('gjjmoney','','公积金余额')"> {{ lianxiinfo.gjjmoney }} </th>
                <th @click="operate('huabei','','花呗额度')"> {{ lianxiinfo.huabei }} </th>
                <th @click="operate('creditCardLimit','','信用卡额度')"> {{ lianxiinfo.creditCardLimit }} </th>
                <th @click="operate('bankLoanLimit','','银行贷款额度')"> {{ lianxiinfo.bankLoanLimit }} </th>
                <th @click="operate('cpnName','','工作单位')"> {{ lianxiinfo.cpnName }} </th>
                <th @click="operate('zhiye','','职业状况')"> {{ lianxiinfo.zhiye }} </th>
                <th @click="operate('incometype',radiolist2,'收入方式')"> {{ lianxiinfo.incometype }} </th>
                <th @click="operate('income','','收入状况')"> {{ lianxiinfo.income }} </th>
                <th @click="operate('marriStatus',radiolist3,'婚姻状况')"> {{ lianxiinfo.marriStatus }} </th>
                <th @click="operate('carLoan',radiolist4,'车贷状况')"> {{ lianxiinfo.carLoan }} </th>
                <th @click="operate('shebao',radiolist6,'社保状况')"> {{ lianxiinfo.shebao }} </th>
                <th @click="operate('resiStatus',radiolist5,'住所性质')"> {{ lianxiinfo.resiStatus }} </th>
            </tr>
        </table>

        <!-- 紧急联系人 -->
        <div class="common-form">紧急联系人（修改后的信息小程序用户可查看，请妥善修改）</div>
        <table border="1" style="border-collapse: collapse;width: 100%;" class="grxx">
            <tr>
                <th> 通讯录姓名 </th>
                <th> 真实姓名</th>
                <th> 关系</th>
                <th> 手机号 </th>
                <th> 操作 </th>
            </tr>
            <tr class="trinfo">
                <th @click="operate('contactName','','通讯录姓名')"> {{ lianxiinfo.contactName }}</th>
                <th @click="operate('jjrealname','','真实姓名')"> {{ lianxiinfo.jjrealname }}</th>
                <th @click="operate('contactRelation',radiolistinfo,'关系')"> {{ lianxiinfo.contactRelation }}</th>
                <th @click="operate('contactPhone','','手机号')"> {{ lianxiinfo.contactPhone }}</th>
                <th @click="mobilecheck(lianxiinfo.contactPhone)" style="color:#0043FF;cursor:pointer;"> 查询 </th>
            </tr>

            <tr class="trinfo">
                <th @click="operate('contactName1','','通讯录姓名')"> {{ lianxiinfo.contactName1 }}</th>
                <th @click="operate('jjrealname1','','真实姓名')"> {{ lianxiinfo.jjrealname1 }}</th>
                <th @click="operate('contactRelation1',radiolistinfo,'关系')"> {{ lianxiinfo.contactRelation1 }}</th>
                <th @click="operate('contactPhone1','','手机号')"> {{ lianxiinfo.contactPhone1 }}</th>
                <th @click="mobilecheck(lianxiinfo.contactPhone1)" style="color:#0043FF;cursor:pointer;"> 查询 </th>
            </tr>

            <tr class="trinfo">
                <th @click="operate('contactName2','','通讯录姓名')"> {{ lianxiinfo.contactName2 }}</th>
                <th @click="operate('jjrealname2','','真实姓名')"> {{ lianxiinfo.jjrealname2 }}</th>
                <th @click="operate('contactRelation2',radiolistinfo,'关系')"> {{ lianxiinfo.contactRelation2 }}</th>
                <th @click="operate('contactPhone2','','手机号')"> {{ lianxiinfo.contactPhone2 }}</th>
                <th @click="mobilecheck(lianxiinfo.contactPhone2)" style="color:#0043FF;cursor:pointer;"> 查询 </th>
            </tr>
        </table>

        <!-- 修改个人信息 修改 -->
        <el-dialog :title="tkzwname" :visible.sync="dialogVisiblegrxx" width="40%" :before-close="handleClose">
            <div v-if="tklist != ''">
                <el-select v-model="lxvalue" placeholder="请选择">
                    <el-option v-for="item in tklist" :key="item.val" :label="item.name" :value="item.val">
                    </el-option>
                </el-select>
            </div>
            <div v-else>
                <el-input v-model="lxvalue" placeholder="请输入内容"></el-input>
            </div>

            <div style="margin-top: 10px;">
                <el-button @click="define(tkname, lxvalue)" type="primary">确 定</el-button>
                <el-button @click="dialogVisiblegrxx = false">取 消</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import OrderApi from '@/api/order.js';
import UserApi from '@/api/user.js';
export default {
    data() {
        return {
            dialogVisiblegrxx:false,
            user_id: "",
            order_id:"",
            order_status:"",
            dialogVisiblegrxx: false,
            tkzwname: '',
            tkname: '',
            tklist: [],
            lianxiinfo: '',
            setlist: [{
                name: '0-10台',
                val: '0'
            },
            {
                name: '10-20台',
                val: '1'
            },
            {
                name: '20-30台',
                val: '2'
            },
            {
                name: '30台以上',
                val: '3'
            },
            ],
            timelist: [{
                name: '一个月以内',
                val: '0'
            },
            {
                name: '1-3个月',
                val: '1'
            },
            {
                name: '3-6个月',
                val: '2'
            },
            {
                name: '6-12个月',
                val: '3'
            },
            {
                name: '12个月以上',
                val: '4'
            },
            ],
            radiolist1: [{
                name: '良好',
                val: '1',
                disabled: false
            },
            {
                name: '违约',
                val: '2',
                disabled: false
            },
            {
                name: '黑户',
                val: '3',
                disabled: false
            }
            ],
            zmxinyongfenlist: [{
                name: '350-550分',
                val: '1'
            },
            {
                name: '550-600分',
                val: '2'
            },
            {
                name: '600-650分',
                val: '3'
            },
            {
                name: '650-700分',
                val: '4'
            },
            {
                name: '700-950分',
                val: '5'
            },
            ],
            lxvalue: '',
            gjjlist: [{
                name: '无公积金',
                val: '1'
            },
            {
                name: '1万元以下',
                val: '2'
            },
            {
                name: '1-2万元',
                val: '3'
            },
            {
                name: '2-3万元',
                val: '4'
            },
            {
                name: '3-5万元',
                val: '5'
            },
            {
                name: '5万元以上',
                val: '6'
            }
            ],
            hblist: [{
                name: '无花呗额度',
                val: '1'
            },
            {
                name: '1000元以下',
                val: '2'
            },
            {
                name: '1000-3000元',
                val: '3'
            },
            {
                name: '3000-5000元',
                val: '4'
            },
            {
                name: '5000-10000元',
                val: '5'
            },
            {
                name: '1万元以上',
                val: '6'
            }
            ],
            xyklist: [{
                name: '无信用卡额度',
                val: '1'
            },
            {
                name: '5000元以下',
                val: '2'
            },
            {
                name: '5000-10000元',
                val: '3'
            },
            {
                name: '1-2万元',
                val: '4'
            },
            {
                name: '2-5万元',
                val: '5'
            },
            {
                name: '5万元以上',
                val: '6'
            }
            ],
            yhlist: [{
                name: '无银行贷款额度',
                val: '1'
            },
            {
                name: '5000元以下',
                val: '2'
            },
            {
                name: '5000-10000元',
                val: '3'
            },
            {
                name: '1-2万元',
                val: '4'
            },
            {
                name: '2-5万元',
                val: '5'
            },
            {
                name: '5万元以上',
                val: '6'
            }
            ],
            radiolist2: [{
                name: '银行转账',
                val: 1,
                disabled: false
            },
            {
                name: '支付宝/微信',
                val: 2,
                disabled: false
            },
            {
                name: '现金收账',
                val: 3,
                disabled: false
            }
            ],
            srlist: [{
                name: '1000元以下',
                val: 1
            },
            {
                name: '1000-3000元',
                val: 2
            },
            {
                name: '3000-5000元',
                val: 3
            },
            {
                name: '5000-7000元',
                val: 4
            },
            {
                name: '7000-9000元',
                val: 5
            },
            {
                name: '9000-10000元',
                val: 6
            },
            {
                name: '1-2万元',
                val: 7
            },
            {
                name: '2-3万元',
                val: 8
            },
            {
                name: '3万元以上',
                val: 9
            },
            ],
            radiolist3: [{
                name: '未婚',
                val: '10',
                disabled: false
            },
            {
                name: '已婚',
                val: '20',
                disabled: false
            },
            {
                name: '丧偶',
                val: '30',
                disabled: false
            },
            {
                name: '离异',
                val: '40',
                disabled: false
            },
            {
                name: '未知',
                val: '99',
                disabled: false
            }
            ],
            radiolist4: [{
                name: '无车贷',
                val: '1',
                disabled: false
            },
            {
                name: '有车贷',
                val: '2',
                disabled: false
            }
            ],
            radiolist5: [{
                name: '自置',
                val: 1,
                disabled: false
            },
            {
                name: '按揭',
                val: 2,
                disabled: false
            },
            {
                name: '亲属楼宇',
                val: 3,
                disabled: false
            },
            {
                name: '宿舍',
                val: 4,
                disabled: false
            },
            {
                name: '租房',
                val: 5,
                disabled: false
            },
            {
                name: '共有住宅',
                val: 6,
                disabled: false
            },
            {
                name: '借住',
                val: 12,
                disabled: false
            },
            {
                name: '未知',
                val: 9,
                disabled: false
            }
            ],
            // 紧急联系人
            radiolistinfo: [{
                name: '父母',
                val: 1,
                disabled: false
            },
            {
                name: '配偶',
                val: 5,
                disabled: false
            },
            {
                name: '其他亲属',
                val: 9,
                disabled: false
            }
            ],
            radiolist6: [{
                name: '无社保',
                val: 1,
                disabled: false
            },
            {
                name: '有社保',
                val: 2,
                disabled: false
            }
            ],

            // setlist: [{
            //     name: '无',
            //     val: 0
            // },
            // {
            //     name: '1-2台',
            //     val: 1
            // },
            // {
            //     name: '3-5台',
            //     val: 2
            // },
            // {
            //     name: '5-7台',
            //     val: 3
            // },
            // {
            //     name: '7-10台',
            //     val: 4
            // },
            // {
            //     name: '10台以上',
            //     val: 5
            // },
            // ],
        };
    },
    props: ['detailinfo'],
    created() {
        this.getDataInfo();
    },
    methods: {
        handleClose(){
            this.dialogVisiblegrxx = false;
            self.lxvalue = '';
            self.tklist = null;
        },
        // 紧急联系人确定
        define(name, data) {
            let param = {};
            param[name] = data;
            param['user_id'] = this.user_id;
            param['order_id'] = this.order_id;
            param['type'] = this.order_status;
            UserApi.edituser1(param, true)
                .then(data => {
                    console.log(data);
                    this.$message({
                        message: '恭喜你，修改成功',
                        type: 'success'
                    });
                    location.reload();
                })
                .catch(error => {
                });
        },
        // 操作修改用户信息
        operate(name, list, zwname) {
            var self = this;
            self.tkzwname = zwname;
            self.tkname = name;
            self.tklist = list;
            this.dialogVisiblegrxx = true;
        },
        mobilecheck(mobile) {
            let Params = { mobile: mobile };
            OrderApi.searchMobile(Params, true)
            .then(data => {
            console.log("成功返回的data", data);
            this.$message({
                message: data.msg,
                type: 'success'
            });
            })
            .catch(error => { });
        },
        // 获取数据
        getDataInfo() {
            let self = this;
            console.log("lianxi", self.detailinfo.user);
            self.lianxiinfo = self.detailinfo.user;
            self.user_id = self.detailinfo.user_id;
            self.order_id = self.detailinfo.order_id;
            self.order_status = self.detailinfo.order_status.text;
            for (let var1 of self.radiolistinfo) {
                if (var1.val == self.lianxiinfo.contactRelation) {
                    self.lianxiinfo.contactRelation = var1.name;
                }
                if (var1.val == self.lianxiinfo.contactRelation1) {
                    self.lianxiinfo.contactRelation1 = var1.name;
                }
                if (var1.val == self.lianxiinfo.contactRelation2) {
                    self.lianxiinfo.contactRelation2 = var1.name;
                }
            }

            for (let var3 of self.radiolist1) {
                if (var3.val == self.lianxiinfo.zhengxin) {
                    self.lianxiinfo.zhengxin = var3.name;
                }
            }

            for (let var9 of self.radiolist2) {
                if (var9.val == self.lianxiinfo.incometype) {
                    self.lianxiinfo.incometype = var9.name;
                }
            }

            for (let var11 of self.radiolist3) {
                if (var11.val == self.lianxiinfo.marriStatus) {
                    self.lianxiinfo.marriStatus = var11.name;
                }
            }

            for (let var12 of self.radiolist4) {
                if (var12.val == self.lianxiinfo.carLoan) {
                    self.lianxiinfo.carLoan = var12.name;
                }
            }

            for (let var13 of self.radiolist5) {
                if (var13.val == self.lianxiinfo.resiStatus) {
                    self.lianxiinfo.resiStatus = var13.name;
                }
            }

            for (let var14 of self.radiolist6) {
                if (var14.val == self.lianxiinfo.shebao) {
                    self.lianxiinfo.shebao = var14.name;
                }
            }

            // return
          
            for (let var1 of self.setlist) {
                if (var1.val == self.lianxiinfo.zaizu) {
                    self.lianxiinfo.zaizu = var1.name;
                }
            }
            for (let var2 of self.timelist) {
                if (var2.val == self.lianxiinfo.zaizutime) {
                    self.lianxiinfo.zaizutime = var2.name;
                }
            }

            for (let var4 of self.zmxinyongfenlist) {
                if (var4.val == self.lianxiinfo.zmxinyongfen) {
                    self.lianxiinfo.zmxinyongfen = var4.name;
                }
            }

            for (let var5 of self.gjjlist) {
                if (var5.val == self.lianxiinfo.gjjmoney) {
                    self.lianxiinfo.gjjmoney = var5.name;
                }
            }

            for (let var6 of self.hblist) {
                if (var6.val == self.lianxiinfo.huabei) {
                    self.lianxiinfo.huabei = var6.name;
                }
            }
            for (let var7 of self.xyklist) {
                if (var7.val == self.lianxiinfo.creditCardLimit) {
                    self.lianxiinfo.creditCardLimit = var7.name;
                }
            }
            for (let var8 of self.yhlist) {
                if (var8.val == self.lianxiinfo.bankLoanLimit) {
                    self.lianxiinfo.bankLoanLimit = var8.name;
                }
            }

            for (let var10 of self.srlist) {
                if (var10.val == self.lianxiinfo.income) {
                    self.lianxiinfo.income = var10.name;
                }
            }

          




        }
    }

};
</script>

<style>
.grxx .trinfo th {
    color: #1890FF;
}
</style>



// WEBPACK FOOTER //
// src/views/order/received/dialog/lianxi.vue